"use client";

import { useGetPlatformLocationsBySubdomain } from "@orval/ageless-companies/ageless-companies";
import type { DisplayAgelessPlatformLocationItem } from "@orval/model";

type UsePlatformLocationsForSubdomainResult = {
  readonly practiceName: string | null;
  readonly locations: DisplayAgelessPlatformLocationItem[];
  readonly isLoading: boolean;
  readonly isError: boolean;
};

/**
 * Fetches the platform's active locations by subdomain. Used by the capture
 * flow to drive the out-of-area location picker without routing through the
 * BookConsultation-specific {@link usePlatformLocations} hook, which bundles
 * nearest-location lookup and expects a postal code.
 */
export function usePlatformLocationsForSubdomain(
  subdomainSlug: string | null | undefined,
): UsePlatformLocationsForSubdomainResult {
  const enabled = Boolean(subdomainSlug);
  const { data, isLoading, isError } = useGetPlatformLocationsBySubdomain(
    { subdomain: subdomainSlug ?? "" },
    {
      query: {
        enabled,
      },
    },
  );

  return {
    practiceName: data?.practiceName ?? null,
    locations: data?.locations ?? [],
    isLoading,
    isError,
  };
}
